import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
function alwaysTrue() {
  return true;
}
export const BaseInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    prefix,
    suffix,
    value,
    type = "text",
    disabled = false,
    size = "middle",
    className = "",
    inputClassName,
    style = {},
    maxLength,
    verifyFn = alwaysTrue,
    verifyText = "",
    placeholder = "",
    ...rest
  } = props;
  const isVerified = useMemo(() => {
    return verifyFn(value);
  }, [value, verifyFn]);
  const inputRef = useRef(null);
  const [isFocus, setIsFocus] = useState(false);
  const handleFocus = e => {
    var _rest_onFocus;
    setIsFocus(true);
    (_rest_onFocus = rest.onFocus) === null || _rest_onFocus === void 0 ? void 0 : _rest_onFocus.call(rest, e);
  };
  const handleBlur = e => {
    var _rest_onBlur;
    setIsFocus(false);
    (_rest_onBlur = rest.onBlur) === null || _rest_onBlur === void 0 ? void 0 : _rest_onBlur.call(rest, e);
  };
  const handleMouseDown = e => {
    if (disabled) return;
    e.target.tagName !== "INPUT" && e.preventDefault();
    if (document.activeElement !== inputRef.current) {
      var _inputRef_current;
      (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames({
        [styles.wrapper]: true,
        [styles.disable]: disabled,
        [styles.focus]: isFocus,
        [styles.error]: !isVerified,
        [styles["wrapper_".concat(size)]]: true,
        [className]: !!className
      }),
      style: style,
      onMouseDown: handleMouseDown,
      ref: ref,
      children: [prefix && prefix, /*#__PURE__*/_jsx("input", {
        ref: inputRef,
        type: type,
        value: value,
        className: classNames(styles.input, inputClassName),
        disabled: disabled,
        ...rest,
        maxLength: maxLength,
        onFocus: handleFocus,
        onBlur: handleBlur,
        placeholder: placeholder
      }), suffix && suffix, !isVerified && /*#__PURE__*/_jsx("div", {
        className: classNames({
          [styles.error_text]: true
        }),
        children: verifyText
      })]
    })
  });
});